import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const initiateSkillset = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/skill-set/initiate?${param}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListSkillset = async (token, refresh_token, param, depot_id, dispatch) => {
    const url = `${GROLOG_URL}/skill-set?${param}&filter=depot_id eq ${depot_id}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getDetailSkillset = async (token, refresh_token, id, dispatch) => {
    const url = `${GROLOG_URL}/skill-set/${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getListSkillsetDropdown = async (token, page, keyword, refresh_token, dispatch) => {
    const params = {
        page: page,
        limit: 10,
        order: 'id asc',
        filter: keyword !== '' ? `depot_name lk ${keyword}` : ''
    }
    const url = `${GROLOG_URL}/depot-list-filter`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, params);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const postSkillset = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/skill-set`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const deleteSkillset = async (token, refresh_token, id, updated_at, dispatch) => {
    const url = `${GROLOG_URL}/skill-set/${id}`
    let result = { data: undefined, ok: false }

    let data = {
        'updated_at': updated_at
    }

    try {
        const response = await doDelete(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const editSkillset = async (token, refresh_token, id, data, dispatch) => {
    const url = `${GROLOG_URL}/skill-set/${id}`
    let result = { data: undefined, ok: false }

    try {
        const response = await doPut(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSearchRecommendation = async (token, refresh_token, depot_id, keyword, dispatch) => {
    const url = `${GROLOG_URL}/skill-set/search?page=1&limit=10&filter=depot_id eq ${depot_id}, skillset_name lk ${keyword}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSearchResult = async (token, refresh_token, depot_id, keyword, dispatch) => {
    const url = `${GROLOG_URL}/skill-set?page=1&limit=10&filter=depot_id eq ${depot_id}, skillset_name lk ${keyword}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
    const url = `${GROLOG_BASE_URL}audit/v1/grolog/audit?page=1&filter=table_name eq skill_set, primary_key eq ${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}